document.addEventListener('alpine:init', () => {
  Alpine.store('cart_toast', {
    visible: false,
    title: '',
    variantTitle: '',
    image: '',
    quantity: 1,
    price: 0,
    _timer: null,

    get formattedPrice() {
      if (typeof window.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
        return window.formatMoney(this.price, window.theme.moneyFormat);
      }
      return '';
    },

    show(data) {
      this.title = data.product_title || data.title || '';
      this.variantTitle =
        data.variant_title && data.variant_title !== 'Default Title'
          ? data.variant_title
          : '';
      // Featured image URL can come in different shapes from the API
      const img = data.featured_image;
      this.image = (img && (img.url || img)) || data.image || '';
      this.quantity = data.quantity || 1;
      // final_line_price is total after discounts; fallback chain for safety
      this.price =
        data.final_line_price ||
        data.line_price ||
        (data.final_price || data.price) * (data.quantity || 1) ||
        0;
      this.visible = true;

      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.visible = false;
        this._timer = null;
      }, 3000);
    },

    hide() {
      this.visible = false;
      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
      }
    },
  });

  window.addEventListener('shapes:cart:item-added', (e) => {
    Alpine.store('cart_toast').show(e.detail);
  });
});
